import React from 'react';
import Img from 'gatsby-image';
import Link from 'components/Link';

import './_Card.scss'

const Card = (props) => {
    
    const evenIndex = props.index === '0' ? true : false;

    const title = props.card.title;
    const image = props.image;
    const button = props.card.button;
    const slug = props.slug;
    const subtitle = props.card.subtitle;

    var style = {
        backgroundColor: props.backgroundColor
    };

    const cardImage = (
        <div className='cardImg shadow' id={evenIndex ? 'right' : null} style={style}>
            <Img className="teach-image" sizes={image} />
        </div>
    )

    const cardContent = (
        <div className='cardContent shadow' id={evenIndex ? null : 'right'} style={style}>
            <h5 className='cardTitle'>{title}</h5>
            <p dangerouslySetInnerHTML={{__html: subtitle}} />
            <Link className="btn-lm btn-lg" to={slug}>{button}</Link>
        </div>
    )

    let content;
    if (evenIndex) {
        content = (
            <div className='cardContainer'>
                {cardImage}
                {cardContent}
            </div>
        )
    } else {
        content = (
            <div className='cardContainer'>
                {cardContent}
                {cardImage}
            </div>
        )
    }

    return (content)
}

export default Card;


// WEBPACK FOOTER //
// ./src/pages/competency/components/_Card.js